import { useCallback, useEffect } from 'react';

import { ConversationAssistantUIModes } from '@atlassian/conversation-assistant';
import { ConversationAssistantButtonNav4 } from '@atlassian/conversation-assistant-ui-components';
import { useRovoExperienceAPIStore } from '@atlassian/rovo-experience-api';

import { RovoSpotlightManager } from 'src/components/navigation/src/components/horizontal-nav/horizontal-platform-search';
import {
  publishScreenEvent,
  publishUiEvent,
} from 'src/utils/analytics/publish';

import { useRovoChatContext } from '../nav-system';

export const TopNavRovo = (): JSX.Element => {
  const { chatState, setChatState, sidebarApi } = useRovoChatContext();

  useEffect(() => {
    publishUiEvent({
      action: 'viewed',
      actionSubject: 'ui',
      actionSubjectId: 'rovoChatButton',
      source: 'navigation',
    });
  }, []);

  const { toggleConversationAssistantUIMode, mode } =
    useRovoExperienceAPIStore();
  const toggleConversationAssistant = useCallback(() => {
    const getNextMode = () => {
      if (ConversationAssistantUIModes.MINI_MODAL === mode) {
        return ConversationAssistantUIModes.SIDEBAR;
      } else if (ConversationAssistantUIModes.SIDEBAR === mode) {
        return undefined;
      } else {
        return ConversationAssistantUIModes.SIDEBAR;
      }
    };

    if (sidebarApi) {
      toggleConversationAssistantUIMode({
        targetMode: getNextMode(),
        sidebarApi,
      });
    } else {
      setChatState(prevState => ({
        isActive: !prevState.isActive,
      }));
    }
  }, [mode, setChatState, sidebarApi, toggleConversationAssistantUIMode]);

  return (
    <RovoSpotlightManager
      onTryChat={() => {
        toggleConversationAssistant();
      }}
      publishScreenEvent={publishScreenEvent}
      publishUiEvent={publishUiEvent}
    >
      <ConversationAssistantButtonNav4
        productKey="bitbucket"
        isActive={chatState.isActive}
        onClick={() => {
          toggleConversationAssistant();
        }}
        siteId={chatState.siteId}
      />
    </RovoSpotlightManager>
  );
};
